var _path, _path2, _path3, _path4, _path5, _path6, _path7, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandAllElementsDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.585 13.585H17.7577L19.6727 15.5L17.7577 17.415H8.585V13.585Z",
    stroke: "#0076A8",
    strokeWidth: 1.17
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 11.5H18.0001L20.0001 13.5",
    stroke: "#0076A8",
    strokeWidth: 1.17
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9.5H18.0001L20.0001 11.5",
    stroke: "#0076A8",
    strokeWidth: 1.17
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 7V5.5H8",
    stroke: "#0076A8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 20.5L6.5 20.5L6.5 19",
    stroke: "#0076A8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 21.5L22.5 19.5L20.5 19.5L20.5 21.5L22.5 21.5Z",
    stroke: "#0076A8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20 5.5L21.5 5.5L21.5 7",
    stroke: "#0076A8"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 5.5,
    x2: 11,
    y2: 5.5,
    stroke: "#0076A8"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 5.5,
    x2: 15,
    y2: 5.5,
    stroke: "#0076A8"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 20.5,
    x2: 11,
    y2: 20.5,
    stroke: "#0076A8"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 5.5,
    x2: 19,
    y2: 5.5,
    stroke: "#0076A8"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 20.5,
    x2: 19,
    y2: 20.5,
    stroke: "#0076A8"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 20.5,
    x2: 15,
    y2: 20.5,
    stroke: "#0076A8"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 21.5,
    y1: 12,
    x2: 21.5,
    y2: 14,
    stroke: "#0076A8"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 21.5,
    y1: 8,
    x2: 21.5,
    y2: 10,
    stroke: "#0076A8"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 21.5,
    y1: 16,
    x2: 21.5,
    y2: 18,
    stroke: "#0076A8"
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 12,
    x2: 6.5,
    y2: 14,
    stroke: "#0076A8"
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 8,
    x2: 6.5,
    y2: 10,
    stroke: "#0076A8"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 16,
    x2: 6.5,
    y2: 18,
    stroke: "#0076A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandAllElementsDefault);
export default __webpack_public_path__ + "static/media/expand-all-elements-default.49f37bd875946a5c38a91ff9b9018444.svg";
export { ForwardRef as ReactComponent };